import { observer } from 'mobx-react';
import React from 'react';
import Skeleton from 'react-loading-skeleton';

import FullProductMatrix from '../../../models/product/FullProductMatrix';
import { modelOf } from '../../../prop-types';

const ProductCollectionMatrixStorageRowSkeleton = ({ productMatrix }) => {
  const renderSkeletonCell = (rowElement) => {
    return (
      <td
        key={`skeleton-${rowElement.id}`}
        className="ProductCollectionMatrixStorageRow__cell"
      >
        <Skeleton width={80} height={16} />
      </td>
    );
  };

  const rowElements = productMatrix.getDisplayColumns();

  return (
    <tr className="ProductCollectionMatrixStorageRow">
      <th className="ProductCollectionMatrixStorageRow__header" scope="row">
        <div className="ProductCollectionMatrixStorageRow__label">
          <Skeleton width={120} height={16} />
          <span style={{ marginLeft: '0.25rem' }}>
            <Skeleton width={50} height={14} />
          </span>
        </div>
      </th>
      {rowElements.map((rowElement) => renderSkeletonCell(rowElement))}
    </tr>
  );
};

ProductCollectionMatrixStorageRowSkeleton.propTypes = {
  productMatrix: modelOf(FullProductMatrix).isRequired,
};

export default observer(ProductCollectionMatrixStorageRowSkeleton);
